import { render, staticRenderFns } from "./index - 副本.vue?vue&type=template&id=eea450dc&scoped=true"
import script from "./index - 副本.vue?vue&type=script&lang=js"
export * from "./index - 副本.vue?vue&type=script&lang=js"
import style0 from "./index - 副本.vue?vue&type=style&index=0&id=eea450dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea450dc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppSwiper: require('/www/wwwroot/pc.hankahuanbao.com/components/app-swiper.vue').default,AppTitle: require('/www/wwwroot/pc.hankahuanbao.com/components/app-title.vue').default,AppImage: require('/www/wwwroot/pc.hankahuanbao.com/components/app-image.vue').default})
